import _ from "lodash";
import Cookies from "js-cookie";
import { Client, User } from "../context/app";
import { ObjectToBeDefined } from "../types/types";

// TODO: check all window variable and add the right types
export const getClient = _.get(window, "react.session.client", {}) as Client;
export const getUser = _.get(window, "react.session.user", {}) as User;
export const userAvatar = _.get(window, "react.session.user_avatar", "") as any;
export const navRoutes = _.get(window, "react.sidebar", []) as any;
export const debugInfo = _.get(window, "react.debug", {}) as any;
export const membershipStatus = _.get(
  window,
  "react.session.membership_status",
  "",
) as any;

function decodeCookieString(p: string) {
  try {
    return decodeURIComponent(p.replace(/\+/g, " "));
  } catch (err) {
    return "";
  }
}

function parseDomains() {
  const sessionDomains = Cookies.get("_pp_session_domains");
  try {
    const domains = JSON.parse(sessionDomains);
    if (Array.isArray(domains)) {
      return domains;
    } else if (domains !== null && typeof domains === "object") {
      return Object.values(domains).map((domainEntry: any) => {
        return {
          ...domainEntry,
          company: decodeCookieString(domainEntry.company),
        };
      });
    } else {
      return [];
    }
  } catch (err) {
    console.error(err);
    return [];
  }
}
export const domains = parseDomains();

export const isUserSuperuser = (user: ObjectToBeDefined) =>
  user.superuser === 1;
